import { initServices } from './serviceConfig'

let _svc
let _that

export default {
  Init: async (that) => {
    _that = that

    _svc = await initServices()

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  // New Guid
  New: () => {
    try {
      return _svc.get('Guid/new')
    } catch {
      return null
    }
  }
}
